import ApplicationComponent from "legacy/ApplicationComponent"
import FormGroup from "legacy/FormGroup"
import SegmentedControl from "legacy/SegmentedControl"
import StripeElement from "legacy/credit-cards/StripeElement"
import {
  afterSetState,
  buildRoute,
  centsToDollars,
  dollarsToCents,
} from "legacy/helpers.es6"
import PropTypes from "prop-types"
import React from "react"

import Modal from "src/components/Modal"

class PaymentSelectSaleModal extends ApplicationComponent {
  constructor(args) {
    super(args)
    this.state = {
      paymentMethod: this.props.sale.paymentType || "credit",
      card: this.props.sale.card || { id: "add_new_card" },
      customerCards: [],
      cashTendered: "",
      checkNumber: this.props.sale.checkNumber || "",
      stripeToken: "",
      showModal: false,
      isLoading: false,
      error: null,
    }
    this.tokenizeCard = this.tokenizeCard.bind(this)
    this.handleStripeError = this.handleStripeError.bind(this)
    this.handleStripeSuccess = this.handleStripeSuccess.bind(this)
    this.handleUpdatePaymentMethod = this.handleUpdatePaymentMethod.bind(this)
    this.handleOpenModal = this.handleOpenModal.bind(this)
    this.handleCloseModal = this.handleCloseModal.bind(this)
    this.getCreditCards = this.getCreditCards.bind(this)
    this.guestSale = this.guestSale.bind(this)
    this.tokenizeAndRetry = this.tokenizeAndRetry.bind(this)
    this.postRetrySale = this.postRetrySale.bind(this)
    this.needsToTokenizeCard = this.needsToTokenizeCard.bind(this)
    this.handleInputCashTendered = this.handleInputCashTendered.bind(this)
    this.handleInputCheckNumber = this.handleInputCheckNumber.bind(this)
    this.handleCardSelect = this.handleCardSelect.bind(this)
    this.renderChangeDue = this.renderChangeDue.bind(this)
    this.renderInputs = this.renderInputs.bind(this)
    this.renderRetryButton = this.renderRetryButton.bind(this)

    this.stripeElement = null
    this.setStripeRef = (element) => {
      this.stripeElement = element
    }
  }

  handleOpenModal() {
    this.setState({ showModal: true })
    afterSetState(this.getCreditCards)
  }

  handleCloseModal() {
    if (this.state.showModal) {
      this.setState({ showModal: false, error: null })
    }
  }

  guestSale() {
    return this.props.sale.contact == null
  }

  getCreditCards() {
    if (this.guestSale()) {
      this.setState({ card: { id: "add_new_card" } })
      return
    }
    // This legacy endpoint only returns Cards. We can remove this when we want to support Bank Accounts in Sales.
    // Note: jQuery ($) is loaded globally
    $.ajax({
      url: `${$context.manageContactsPath}/${this.props.sale.contact.encodedId}/cards/legacy`,
      type: "GET",
      dataType: "json",
      contentType: "application/json",
      success: (data) => {
        this.setState({ customerCards: data })
      },
    })
  }

  tokenizeAndRetry() {
    if (this.needsToTokenizeCard()) {
      this.tokenizeCard()
    } else {
      this.postRetrySale()
    }
  }

  postRetrySale() {
    this.setState({ isLoading: true })
    const reqUrl = buildRoute($context.retrySalePath, {
      sale_id: this.props.sale.id,
    })
    const reqBody = {
      stripe_card_token: this.state.stripeToken,
      stripe_card_id:
        this.state.card.id === "add_new_card" ? null : this.state.card.id,
      payment_type: this.state.paymentMethod,
      check_number: this.state.checkNumber,
      contact_id: this.guestSale() ? null : this.props.sale.contact.id,
      contact: {
        email: this.guestSale() ? null : this.props.sale.contact.email,
      },
    }
    // Note: jQuery ($) is loaded globally
    $.ajax({
      url: reqUrl,
      data: JSON.stringify(reqBody),
      type: "POST",
      dataType: "json",
      contentType: "application/json",
      success: (data) => {
        // Note: Amplitude is loaded globally
        Amplitude.trackEvent("web_pos:retry_pressed", {
          sale_id: this.props.sale.id,
          payment_type: this.state.paymentMethod,
        })
        this.setState({ isLoading: false })
        this.props.handleProcessing(data.responseJSON)
        this.handleCloseModal()
      },
      error: (data) => {
        this.setState({ isLoading: false })
        this.setState({ error: data.responseJSON.error })
      },
    })
  }

  tokenizeCard() {
    this.stripeElement.createStripePaymentMethod()
  }

  needsToTokenizeCard() {
    return (
      this.state.paymentMethod === "credit" &&
      this.state.card.id === "add_new_card" &&
      !this.state.stripeToken
    )
  }

  handleInputCashTendered(cashTendered) {
    this.setState({ cashTendered })
  }

  handleInputCheckNumber(checkNumber) {
    this.setState({ checkNumber })
  }

  handleCardSelect(cardId) {
    this.setState({
      card: {
        ...this.state.card,
        id: cardId,
      },
    })
  }

  handleStripeSuccess(response) {
    this.setState({ stripeToken: response.id })
    this.postRetrySale()
  }

  handleStripeError() {
    this.setState({ error: "Error creating card." })
  }

  renderChangeDue() {
    if (this.state.cashTendered > 0 && this.props.sale.totalPrice > 0) {
      return centsToDollars(
        parseFloat(dollarsToCents(this.state.cashTendered)) -
          this.props.sale.totalPrice
      )
    }
  }

  handleUpdatePaymentMethod(paymentMethod) {
    this.setState({ paymentMethod })
  }

  renderInputs() {
    switch (this.state.paymentMethod) {
      case "credit":
        return (
          <div>
            {this.guestSale() && (
              <p>For guest sales, you must add the card again.</p>
            )}
            <FormGroup
              inputType="select"
              label="Card"
              labelClassName="mt-1 w-24"
              value={this.state.card.id}
              name="credit"
              onChange={(event) => this.handleCardSelect(event.target.value)}
              className="mt-5 flex gap-x-4"
            >
              <option defaultValue value="select_card">
                Select an option:
              </option>
              {this.state.customerCards.map((card) => (
                <option
                  key={card.stripePaymentMethodId}
                  value={card.stripePaymentMethodId}
                >
                  {card.title}
                </option>
              ))}
              <option value="add_new_card">Add New Card</option>
            </FormGroup>
            {this.state.card.id === "add_new_card" && (
              <StripeElement
                ref={this.setStripeRef}
                successCallback={this.handleStripeSuccess}
                errorCallback={this.handleStripeError}
              />
            )}
          </div>
        )
      case "cash":
        return (
          <div>
            <div className="mt-5 grid grid-cols-2 rounded bg-gray-100 p-4">
              <p>Total Due</p>
              <p className="text-right">
                {centsToDollars(this.props.sale.totalPrice)}
              </p>
              <hr className="col-span-full col-start-1 m-0 mb-1" />
              <FormGroup
                inputType="currency"
                label="Cash Tendered"
                labelClassName="mt-2.5 w-72"
                value={this.state.cashTendered}
                name={this.state.paymentMethod}
                onChange={(event) =>
                  this.handleInputCashTendered(event.target.value)
                }
                className="col-span-full mb-1.5 flex gap-x-4"
              />
              <hr className="col-span-full col-start-1 m-0 mb-1" />
              <p className="mt-2.5">Change Due</p>
              <p className="mt-2.5 text-right font-bold">
                {this.renderChangeDue()}
              </p>
            </div>
          </div>
        )
      case "check":
        return (
          <FormGroup
            inputType="input"
            label="Check #"
            labelClassName="mt-1 w-24"
            value={this.state.checkNumber}
            name="check"
            onChange={(event) =>
              this.handleInputCheckNumber(event.target.value)
            }
            className="mt-5 flex gap-x-4"
          />
        )
    }
  }

  renderRetryButton() {
    return (
      <div>
        {this.state.error && (
          <p className="text-danger font-bold">{this.state.error}</p>
        )}
      </div>
    )
  }

  render() {
    return (
      <div>
        <div className="m-0">
          <button
            type="button"
            className="btn btn-secondary mr-1 w-14"
            onClick={this.handleOpenModal}
          >
            Settle
          </button>
        </div>
        <Modal
          isOpen={this.state.showModal}
          onClose={this.handleCloseModal}
          size="mediumFixed"
        >
          <Modal.Header title="Select payment method" />
          <Modal.Body>
            <div className="mt-2">
              <SegmentedControl
                style="blue"
                segments={[
                  {
                    id: "credit",
                    title: "Card",
                  },
                  {
                    id: "cash",
                    title: "Cash",
                  },
                  {
                    id: "check",
                    title: "Check",
                  },
                ]}
                handleSelection={this.handleUpdatePaymentMethod}
                selectedSegment={this.state.paymentMethod}
              />
              {this.renderInputs()}
              {this.renderRetryButton()}
            </div>
          </Modal.Body>
          <Modal.Footer
            cancelBtnText="Nevermind"
            confirmBtnText="Retry payment"
            onClose={this.handleCloseModal}
            onSubmit={this.tokenizeAndRetry}
            confirmBtnLoading={this.state.isLoading}
          />
        </Modal>
      </div>
    )
  }
}

PaymentSelectSaleModal.propTypes = {
  sale: PropTypes.shape({
    id: PropTypes.string.isRequired,
    paymentType: PropTypes.string,
    totalPrice: PropTypes.number.isRequired,
    checkNumber: PropTypes.string,
    card: PropTypes.object,
    contact: PropTypes.shape({
      id: PropTypes.string,
      encodedId: PropTypes.string,
      email: PropTypes.string,
    }),
  }).isRequired,
  scheduledPayment: PropTypes.object,
  handleProcessing: PropTypes.func.isRequired,
}

PaymentSelectSaleModal.defaultProps = {
  scheduledPayment: null,
}

export default PaymentSelectSaleModal
